import { Close } from '@mui/icons-material';
import { Card, IconButton, Stack, type SxProps, type Theme, Typography, type TypographyProps } from '@mui/material';
import { useState } from 'react';
import settings from '/@/core/settings';
import colors from '../../theme-provider/colors';

const InfoBanner = ({
    children,
    color,
    elevation = 0,
    icon,
    canBeClosed = false,
    size = 'medium',
    sx,
    TypographyProps,
}: {
    children: string | JSX.Element;
    color: 'inactive' | 'info';
    elevation?: number;
    icon?: JSX.Element;
    canBeClosed?: boolean;
    size?: 'medium' | 'large';
    sx?: SxProps<Theme>;
    TypographyProps?: TypographyProps;
}) => {
    const [closed, setClosed] = useState(false);

    if (closed) return null;

    return (
        <Card
            sx={{
                background: color === 'info' ? colors.themes[settings.app.theme].mui.primary.infoBackground : '#F5F5F5',

                ...sx,
            }}
            elevation={elevation}
        >
            <Stack spacing={2} direction='row' alignItems='center' p={2}>
                {icon && icon}

                <Typography
                    color={color === 'inactive' ? 'primary.mui.inactive' : 'primary'}
                    variant={size === 'medium' ? 'body2' : 'h6'}
                    fontWeight={size === 'medium' ? undefined : 500}
                    {...TypographyProps}
                >
                    {children}
                </Typography>

                {canBeClosed && (
                    <IconButton
                        color='primary.mui.inactive'
                        size={'small'}
                        sx={{ ml: 'auto !important' }}
                        onClick={() => setClosed(true)}
                    >
                        <Close />
                    </IconButton>
                )}
            </Stack>
        </Card>
    );
};

export default InfoBanner;
